import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-19711
// Промо нейрофильтра на лендинге promo/quota

/** id промо - для включения нужно будет включать фичу 3promo-enable-{id} */
export const PROMO_ID = 'neurofilter';
/** Ключ для локалстораджа от баннера */
export const storageKeyForBanner = `3promo:${PROMO_ID}`;

/** Временной промежуток между показами одной и той же промки, в секундах */
export const showInterval: number = +getFeature(`${PROMO_ID}-show-interval`) || 604800;
/** Максимальное количество закрытий промки (на крестик в баннере / на primary кнопку) */
export const closeLimit: number = +getFeature(`${PROMO_ID}-close-limit`) || 3;
/** Максимальное количество показов, в которых не взаимодействуют с промкой */
export const showLimit: number = +getFeature(`${PROMO_ID}-show-limit`) || 3;

export const isFeatureNeurofilterPromo = isFeature(`3promo-enable-${PROMO_ID}`);

export const trial256gbNeurofilterPromo = getFeature(`${PROMO_ID}-trial`) || 'W256GB_1m_neurofilter_force_trial';
